export default __webpack_public_path__ + "static/media/Group 196.ffdc0703.svg";